var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapUserMarker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6 12C21.6 17.3019 17.3019 21.6 12 21.6C6.69807 21.6 2.4 17.3019 2.4 12C2.4 6.69807 6.69807 2.4 12 2.4C17.3019 2.4 21.6 6.69807 21.6 12Z",
    fill: "#E8474E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0697 12.8133H11.1939L10.526 12.5391C9.78535 12.3047 9.21582 11.9461 8.81738 11.4633C8.41895 10.9758 8.21973 10.3711 8.21973 9.64922C8.21973 8.98828 8.36504 8.42813 8.65566 7.96875C8.95098 7.50938 9.36816 7.16016 9.90723 6.92109C10.451 6.68203 11.0932 6.5625 11.8338 6.5625H15.1104V16.8H13.7533V7.67344H11.8338C11.0838 7.67344 10.5189 7.85156 10.1393 8.20781C9.76426 8.56406 9.57676 9.04453 9.57676 9.64922C9.57676 10.043 9.65879 10.3945 9.82285 10.7039C9.9916 11.0133 10.24 11.257 10.5682 11.4352C10.8963 11.6133 11.3041 11.7023 11.7916 11.7023H14.0768L14.0697 12.8133ZM11.7635 12.1102L9.27441 16.8H7.83301L10.3924 12.1102H11.7635Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapUserMarker);
export default __webpack_public_path__ + "static/media/map-user-marker.824cf5c7dfd0bb92ede9726071356301.svg";
export { ForwardRef as ReactComponent };